import React from "react";
import { Navbar } from "./NavBar";
import { ContactForm } from "../components/ContactForm";
export const Contact = () => {
  return (
    <div>
      <Navbar />
      <ContactForm />
    </div>
  );
};
